@if(isNotifValid(item)){
  <a (click)="read()" class="root-container" [ngClass]="{'unread': !notification().read_at}">
    <i [class]="['bi', 'icon', item.icon]"></i>
    <div class="body">
      <h4 class="title">{{ item.title }}</h4>
      <p class="description">{{ item.description }}</p>
      <span class="time">{{ item.created_at | date: 'medium' }}</span>
    </div>
  </a>
}
